
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useIsMobile } from '@/hooks/use-mobile';

interface TeamMember {
  name: string;
  role: string;
  initials: string;
  image?: string;
}

const TeamGrid = ({ teamMembers }: { teamMembers: TeamMember[] }) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="mb-16">
      <h2 className="text-2xl md:text-3xl font-serif font-semibold text-patrimoine-dark mb-6 text-center">Notre Équipe</h2>
      <div className="w-24 h-1 bg-patrimoine-gold mx-auto mb-8"></div>
      <p className="text-lg text-center text-patrimoine-muted max-w-3xl mx-auto mb-12">
        Découvrez les professionnels qui composent notre équipe et qui contribuent quotidiennement à l'excellence de nos services.
      </p>
      
      <div className={`grid grid-cols-1 ${isMobile ? "sm:grid-cols-2" : "sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5"} gap-6 mb-8`}>
        {teamMembers.map((member, index) => (
          <Card key={index} className="hover:shadow-lg transition-shadow border-patrimoine-gold/10">
            <CardContent className="flex flex-col items-center p-6 text-center">
              <Avatar className="h-24 w-24 mb-4 bg-patrimoine-gold/10">
                {member.image ? (
                  <AvatarImage src={member.image} alt={member.name} />
                ) : (
                  <AvatarFallback className="bg-patrimoine-gold/10 text-patrimoine-dark font-medium">
                    {member.initials}
                  </AvatarFallback>
                )}
              </Avatar>
              <h3 className="font-serif font-semibold text-patrimoine-dark mb-1">{member.name}</h3>
              <p className="text-sm text-patrimoine-muted">{member.role}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default TeamGrid;
